import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectsComponent } from '../projects/projects.component';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent   {

  constructor(public dialog:MatDialog) { }



  openLoginForm(){
this.dialog.open(ProjectsComponent,{width:'900px',height:'650px',})
  }
  
}

